/**
 * Exit intent -> a LogRocket `exit_intent` event that triggers the exit survey.
 *
 * LogRocket itself is loaded by the LogRocket Shopify app embed. It has no
 * native exit trigger, but its surveys can fire on a custom event, so this
 * watches for the pointer leaving the window through the top edge (towards the
 * tabs, address bar or close button), the signal Hotjar uses, and reports it
 * once per session. The same event name is sent by the Gang Sheet Builder, so
 * one survey trigger covers both.
 *
 * Desktop only: touch devices have no pointer to leave the window.
 */
(function () {
  var EVENT = 'exit_intent';
  var FIRED_KEY = 'exit_intent_fired';
  // Ignore exits in the first seconds, when a shopper reaching for a tab is not leaving.
  var ARM_DELAY_MS = 10000;
  // A fast flick out of the window can report a last position a few pixels below the edge.
  var TOP_EDGE_PX = 10;

  if (typeof window.matchMedia !== 'function' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var storage = null;
  try {
    storage = window.sessionStorage;
    if (storage.getItem(FIRED_KEY)) return;
  } catch (e) {
    // Blocked storage (privacy settings): fall back to once per page load.
  }

  var armedAt = Date.now() + ARM_DELAY_MS;

  function onMouseOut(e) {
    // relatedTarget is set when the pointer moves onto another element in the page.
    if (e.relatedTarget || e.clientY > TOP_EDGE_PX || Date.now() < armedAt) return;
    // A held button means a drag that overshot the window, not an exit.
    if (e.buttons) return;

    try {
      if (storage && storage.getItem(FIRED_KEY)) return document.removeEventListener('mouseout', onMouseOut);
    } catch (err) {
      // Storage blocked: still report this one.
    }
    // Spend the once-per-session budget only on an exit that reached LogRocket.
    if (!window.LogRocket) return;
    try {
      window.LogRocket.track(EVENT, { path: window.location.pathname });
    } catch (err) {
      return; // Analytics must never break the page.
    }
    document.removeEventListener('mouseout', onMouseOut);
    try {
      if (storage) storage.setItem(FIRED_KEY, '1');
    } catch (err) {
      // Storage full or blocked: once per page load instead.
    }
  }

  document.addEventListener('mouseout', onMouseOut);
})();
